import Layout, { PageHeader } from "../components/Layout";
import { LegalBody } from "./Privacy";

const SECTIONS = [
  ["Nature of service", "Consultations are conducted by video under the Telemedicine Practice Guidelines (India). They provide medical opinion and guidance and do not replace in-person examination where it is needed."],
  ["Not for emergencies", "This service is not intended for medical emergencies. Please visit the nearest hospital in an emergency."],
  ["Fees and payment", "New patient consultation: ₹1,800. Follow-up consultation: ₹1,500. Fees are payable in advance via Razorpay."],
  ["Cancellation and refunds", "Full refund for cancellations made at least 24 hours before the appointment. Cancellations within 24 hours or missed appointments are not refundable."],
  ["Patient responsibilities", "Provide accurate information and share relevant reports 24–72 hours in advance. Join on time from a quiet place with a stable connection."],
  ["Limitation", "Advice is based on the information and reports shared. Final treatment decisions rest with the patient and their treating team."],
];

export default function Terms() {
  return (
    <Layout>
      <PageHeader eyebrow="Legal" title="Terms of Service" />
      <LegalBody sections={SECTIONS} />
    </Layout>
  );
}
